<div *ngIf="dataLoaded == false" class="d-flex justify-content-center">
  <div class="spinner-border text-success" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
<div class="container">
  <div class="container-fluid" *ngIf="dataLoaded">
    <div class="card">
      <h4 class="card-header">Yeni Talep Oluştur</h4>
      <div class="card-body">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="row">
            <!-- Sol sütun -->
            <div class="col-md-6">


              <div class="form-group">
                <label for="status">Kayıt Tipileri (Zorunlu)</label>
                <select class="form-control" formControlName="cihazturid" (change)="changeCity($event)">
                  <option value="">Kayıt Tipi Seçiniz</option>
                  <option *ngFor="let suit of kayitTurModels" value="{{ suit.Id }}">{{ suit.Name }}</option>
                </select>
              </div>

              <div class="form-group">
                <label for="text">Konu (Zorunlu)</label>
                <input type="text" formControlName="konu" class="form-control" />
              </div>



            </div>

            <!-- Sağ sütun -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="talepedenAdSoyad">Talep Eden Kişi (Zorunlu)</label>
                <input id="talepedenAdSoyad" formControlName="talepedenAdSoyad" type="text" class="form-control" />
              </div>

              <div class="form-group">
                <label for="talepedenCepTel">Talep Eden Kişi Cep Telefonu (Zorunlu)</label>
                <input id="talepedenCepTel" formControlName="talepedenCepTel" type="text" class="form-control" />
              </div>


            </div>

          </div>

          <div class="col-md-12">

            <div class="form-group">
              <label for="text">Şikayet (Zorunlu)</label>
              <textarea formControlName="sikayet" class="form-control" rows="3"></textarea>
            </div>

            <div class="form-group">
              <label for="file">Dosya</label>
              <input formControlName="file" id="file" type="file" multiple class="form-control"
                (change)="onFileChange($event)" />
            </div>
          </div>
          <!-- Cihaz bilgileri -->
          <div class="form-group mt-4">
            <label>
              <input type="checkbox" formControlName="cihazEklenecekMi" (change)="toggleCihazEkleme()" />
              Cihaz Eklenecek Mi?
            </label>
          </div>

          <div *ngIf="cihazEklenecek" class="mt-3">
            <div formArrayName="cihazlar">
              <div *ngFor="let cihaz of cihazlar.controls; let i = index" [formGroupName]="i" class="border p-3 mb-3">
                <div class="form-group">
                  <label for="marka">Marka</label>
                  <input id="marka" formControlName="marka" type="text" class="form-control" />
                </div>
                <div class="form-group">
                  <label for="model">Model</label>
                  <input id="model" formControlName="model" type="text" class="form-control" />
                </div>
                <div class="form-group">
                  <label for="serino">Seri No</label>
                  <input id="serino" formControlName="serino" type="text" class="form-control" />
                </div>
                <div class="form-group">
                  <label for="barkod">Barkod</label>
                  <input id="barkod" formControlName="barkod" type="text" class="form-control" />
                </div>
                <button type="button" class="btn btn-danger" (click)="removeCihaz(i)">Cihazı Kaldır</button>
              </div>
            </div>
            <button type="button" class="btn btn-success" (click)="addCihaz()">Cihaz Ekle</button>
          </div>

          <!-- Form gönderme butonu -->
          <div class="form-group text-center mt-3">
            <button [disabled]="loading" class="btn btn-primary">
              <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
              Oluştur
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>